<template>
  <div class="project-list-box">
    <template v-if="datasReady">
      <template v-if="data.length > 0">
        <template v-if="tabType !== 'realback'">
          <project-item
            v-for="(item, index) in data"
            :key="index"
            :admin="datas.isadmin"
            :founder="datas.isfounder"
            :class="{'mr-0':(index + 1) % 3 === 0}"
            :project-item-data="item"
          />
        </template>
        <template v-if="tabType === 'realback'">
          <project-item-realback
            v-for="(item, index) in data"
            :key="index"
            :project-item-data="item"
            :class="{'mr-0':(index + 1) % 3 === 0}"
          />
        </template>
        <div
          v-if="isManage"
          class="create-project-btn"
          @click="createProject"
        >
          <i class="iconfont iconicon-test10" />
          <h3>创建项目</h3>
        </div>
      </template>
      <div
        v-else
        class="no-org-content "
      >
        <!-- <i class="icon iconfont iconicon-test38 no-org-pic" /> -->
        <img
          src="@/assets/images/blank.png"
          class="logo-img"
        >
        <p>
          {{ tipTxt }}
        </p>
        <a-button
          v-if="isManage"
          type="primary"
          class="create-org-btn"
          @click.native="createProject"
        >
          <!-- {{ $t('message["129"]') }} -->
          创建项目
        </a-button>
      </div>
      <create-pro-dialog
        v-if="tabType !== 'realback'"
        ref="createDialog"
        :c-id="$route.query.cid * 1"
      />
      <edit-realback-pro-dialog
        v-if="tabType === 'realback'"
        ref="createDialog"
        :c-id="$route.query.cid * 1"
      />
    </template>
    <template v-else>
      <a-spin />
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ProjectItem from './ProjectItem'
import ProjectItemRealback from './ProjectItemRealback'
import CreateProDialog from './createPro/CreateProDialog'
import EditRealbackProDialog from './createPro/EditRealbackProDialog'

export default {
  components: {
    ProjectItem,
    ProjectItemRealback,
    CreateProDialog,
    EditRealbackProDialog
  },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    ...mapState('organization/org', ['datasReady', 'datas']),
    ...mapState(['isManage']),
    baseinfo () {
      const { baseinfo = {} } = this.$store.state
      return baseinfo
    },
    tabType () {
      const { type } = this.$route.query
      return type
    },
    tipTxt () {
      const { list = {} } = this.datas
      let str = ''
      if (!Object.keys(list).length) {
        str = '未参与当前组织下任何项目'
      } else if (this.tabType === 'inquery') {
        str = '当前组织下未创建询盘管理类项目'
      } else if (this.tabType === 'member') {
        str = '当前组织下未创建会员管理类项目'
      } else if (this.tabType === 'realback') {
        str = '当前组织下未创建广告回传管理类项目'
      }
      return str
    }
  },

  methods: {
    createProject () {
      this.$refs.createDialog.changeVisible(true)
    }
  }
}
</script>
<style lang="scss" scoped>
.project-list-box{
  width: 1200px;
}
.create-project-btn {
  float: left;
  width: 380px;
  height: 200px;
  border-radius: 4px;
  border: 2px solid #EBEBEB;
  text-align: center;
  padding-top: 64px;
  cursor: pointer;
  .iconicon-test10 {
    font-size: 32px;
    color: #b3b3b3;
    line-height: 32px;
  }
  h3 {
    color: #666;
    line-height: 24px;
    padding-top: 16px;
  }
}
.no-org-content::v-deep {
  margin: 0 auto;
  text-align: center;
  line-height: 24px;
  font-weight: bold;
  padding: 100px 0 100px;
  box-sizing: content-box;

  .org-create-box {
    float: none !important;
    .ant-btn {
      margin: 0 16px;
    }
  }
  .logo-img {
    width: 160px;
    margin: 0 auto;
  }
  /* .no-org-pic {
    display: block;
    margin: 0 auto 24px;
    font-size: 40px;
    color:#d6d6d6;
  } */
  p {
    margin-bottom: 12px;
    color: #b3b3b3;
  }
}
</style>
